module.exports = __webpack_public_path__ + "static/media/index-ad-img3-3.e3ea6686.png";